import { ComponentRef, Directive, ElementRef, Input, NgZone, OnChanges, OnDestroy, OnInit, Renderer2, ViewContainerRef, inject } from "@angular/core";
import { LoaderComponent } from "../../components/loader/loader.component";

@Directive({
  selector: "[relativeLoader]",
  standalone: true
})
export class RelativeLoaderDirective implements OnInit, OnChanges, OnDestroy {
  private renderer = inject(Renderer2);
  private el = inject(ElementRef);
  private viewContainerRef = inject(ViewContainerRef);
  private ngZone = inject(NgZone);

  maxHeight = 100;
  minHeight = 10;
  gap = 10;
  currentHeight = 0;
  divMinHeight = 50;
  private resizeObserver?: ResizeObserver;

  private loaderRef: ComponentRef<LoaderComponent> | null = null;
  @Input() loading: boolean = false;

  constructor() {
    this.resizeObserver = new ResizeObserver(entries => {
      for (const { } of entries) {
        this.ngZone.run(() => {
          this.resizeLoader();
        });
      }
    });

    this.resizeObserver.observe(this.el.nativeElement);
  }

  ngOnInit(): void {
    this.renderer.setStyle(this.el.nativeElement, 'min-height', `${this.divMinHeight}px`);
  }

  ngOnChanges(): void {
    if (this.loading && this.el) {
      this.loaderRef = this.viewContainerRef.createComponent(LoaderComponent);
      this.renderer.appendChild(this.el.nativeElement, this.loaderRef.location.nativeElement);
      this.loaderRef?.setInput('mainDivClass', 'relative-overlay');
      this.loaderRef?.setInput('containerDivClass', 'relative-spinner-container');
      this.loaderRef?.setInput('isRelativeLoader', true);
      this.resizeLoader();
    } else {
      if (this.loaderRef) {
        this.renderer.removeChild(this.el.nativeElement, this.loaderRef.location.nativeElement);
        this.loaderRef.destroy();
        this.loaderRef = null;
      }
    }
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
  }

  resizeLoader(): void {
    const parentHeight = Math.floor(this.getElementContentHeight(this.el.nativeElement));
    let newHeight = this.minHeight;
    if (parentHeight > this.maxHeight)
      newHeight = parentHeight > this.maxHeight + this.gap ? this.maxHeight : this.maxHeight - this.gap;
    else if (parentHeight <= 0)
      newHeight = this.minHeight;
    else
      newHeight = parentHeight - this.gap;

    newHeight = newHeight <= 0 ? this.minHeight : newHeight;
    this.currentHeight = newHeight;
    this.loaderRef?.setInput('diameter', newHeight);
  }

  getElementContentHeight(element: HTMLElement) {
    const styles = window.getComputedStyle(element);
    const padding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
    return element.clientHeight - padding;
  }
}